import { S } from 'src/shared/styled/S'
import { Box, Typography } from '@mui/material'
import { AddButton } from 'src/shared/button/Buttons'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import { useMessageSource } from 'src/i18n/useMessageSource'
import { COLORS } from 'src/theme/colors'

interface CriteriaGroupsToolbarProps {
  numResults: number
  onAddCriteriaGroupClick: React.MouseEventHandler<HTMLButtonElement>
}

export const CriteriaGroupsGridToolbar = ({ numResults, onAddCriteriaGroupClick }: CriteriaGroupsToolbarProps) => {
  const { getMessage } = useMessageSource()

  return (
    <S.DataGrid.ToolbarContainer sx={{ backgroundColor: COLORS.grey }} style={{ paddingInline: '0' }}>
      <Typography variant="subtitle1">
        {`${getMessage('label.configuration.grid.toolbar.results')}: ${numResults}`}
      </Typography>
      <Box>
        <AddButton
          messageKey="label.configuration.criteria.group.grid.toolbar.create.button"
          startIcon={<AddOutlinedIcon />}
          onClick={onAddCriteriaGroupClick}
        />
      </Box>
    </S.DataGrid.ToolbarContainer>
  )
}
